const OauthProviderForm = () => import("@/application/modules/configuration/oauth_provider/views/OauthProviderForm");

export default {
	children: [
		// {
		// 	path: "configuration/oauth/providers",
		// 	name: "oauth_provider",
		// 	component: OauthProvider,
		// 	meta: {
		// 		requiresAuth: true,
		// 		title: "lang.oauth_provider",
		// 		restrict_by_login_type: [
		// 			"customer_support",
		// 			"administrator",
		// 			"employee",
		// 			"developer",
		// 			"csr",
		// 			"customer",
		// 			"dispatcher",
		// 			"technician",
		// 			"driver",
		// 			"dispenser_mgr",
		// 			"employee",
		// 			"customer",
		// 		],
		// 		restrict_by_permission: ["configuration.read"],
		// 	},
		// },
		{
			path: "configuration/oauth/providers/:third_party?",
			name: "oauth_provider_form",
			component: OauthProviderForm,
			meta: {
				requiresAuth: true,
				title: "lang.oauth_provider",
				restrict_by_login_type: [
					"customer_support",
					"administrator",
					"employee",
					"developer",
					"csr",
					"customer",
					"dispatcher",
					"technician",
					"driver",
					"dispenser_mgr",
					"employee",
					"customer",
				],
				restrict_by_permission: ["configuration.read"],
			},
		},
	],
};
